import { tv } from 'tailwind-variants'

export const radioCard = tv({
  slots: {
    container: 'group relative flex cursor-pointer flex-col hover:opacity-70 active:opacity-70',
    card: 'flex flex-grow flex-row items-center gap-x-4 rounded-lg border border-grey-300 p-4',
    iconContainer: 'group-hover:opacity-70',
    textContainer: 'flex flex-1 flex-grow flex-col justify-between gap-y-1 group-hover:opacity-70',
    titleContainer: 'flex flex-row justify-between gap-x-4',
    tag: 'h-5 w-full bg-grey-300 text-black/70',
  },
  variants: {
    layout: {
      wide: {},
      compact: {
        container: 'flex-1',
        card: [
          'ios:gap-x-0 ios:flex-none ios:flex-grow android:flex-none android:gap-x-0 ios:flex-col ios:gap-y-2.5 android:gap-y-2.5 ios:px-2.5 ios:py-4 android:flex-col android:px-2.5 android:py-4',
          'sm:flex-col sm:gap-x-0 sm:gap-y-2.5 sm:px-2.5 sm:py-4',
        ],
        textContainer: 'sm:items-center',
        titleContainer: [
          'ios:gap-x-0 android:gap-x-0 ios:gap-y-1 ios:space-between android:space-between android:gap-y-1 ios:flex-col android:flex-col',
          'sm:flex-col sm:justify-start sm:gap-x-0 sm:gap-y-1',
        ],
      },
    },
    hasBottomTag: {
      true: {
        card: 'rounded-b-none',
      },
    },
    hasTopTag: {
      true: {
        card: 'rounded-t-none',
      },
    },
    hasTopTags: {
      true: {},
    },
    hasBottomTags: {
      true: {},
    },
    isUntouched: {
      true: {
        tag: 'bg-grey-100',
      },
    },
    isSelected: {
      true: {
        card: 'border-2 border-deep-forest',
        tag: 'bg-deep-forest text-white',
      },
    },
    disabled: {
      true: {
        card: 'cursor-default opacity-40',
        iconContainer: 'opacity-40',
        tag: 'opacity-40',
      },
    },
  },
  compoundVariants: [
    {
      isSelected: true,
      layout: 'wide',
      className: {
        card: ['p-3.5'],
      },
    },
    {
      isSelected: true,
      layout: 'compact',
      className: {
        card: 'px-2 py-3.5',
      },
    },
    {
      hasTopTag: false,
      hasTopTags: true,
      layout: 'compact',
      className: {
        container: 'pt-5',
      },
    },
    {
      hasBottomTag: false,
      hasBottomTags: true,
      layout: 'compact',
      className: {
        container: 'pb-5',
      },
    },
  ],
})
